import React from 'react';
import MainLayout from '../MainLayout';
import SignIn from '../../pages/SignIn';
import SignUp from '../../pages/SignUp';
import Fgts from '../../pages/Fgts';
import Consignado from '../../pages/Consignado';
import Portabilidade from '../../pages/Portabilidade';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import TermsOfUse from '../../pages/TermsOfUse';
import PageNotFound from '../../pages/NotFound';
import RecoverPassword from '../../pages/RecoverPassword';
import ResendEmail from '../../pages/ResendEmail';
import ReCaptcha from '../../pages/ChatCommerce/ReCaptcha';

const publicRoutes = [
  {
    path: '/',
    element: (
      <MainLayout>
        <Fgts />
      </MainLayout>
    ),
  },
  { path: '/signin', element: <SignIn /> },
  { path: '/signup', element: <SignUp /> },
  { path: '/recover-password', element: <RecoverPassword /> },
  { path: '/resend-confirmation-email', element: <ResendEmail /> },
  {
    path: '/fgts',
    children: [
      {
        path: 'parceiro/:partnerParam',
        element: (
          <MainLayout>
            <Fgts />
          </MainLayout>
        ),
      },
      {
        path: 'parceiro/:partnerParam/:cpfParam/:bankNumberParam/:agencyParam/:accountNumberParam',
        element: (
          <MainLayout>
            <Fgts />
          </MainLayout>
        ),
      },
      {
        path: 'parceiro/:partnerParam/:cpfParam/:accountNumberParam',
        element: (
          <MainLayout>
            <Fgts />
          </MainLayout>
        ),
      },
      {
        path: 'parceiro/:partnerParam/:cpfParam',
        element: (
          <MainLayout>
            <Fgts />
          </MainLayout>
        ),
      },
    ],
  },
  { path: '/consignado', element: <Consignado /> },
  { path: '/portabilidade', element: <Portabilidade /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-of-use', element: <TermsOfUse /> },
  {
    path: '/chat-commerce/recaptcha/:orderUuid/:key/:version',
    element: <ReCaptcha />,
  },
  { path: '*', element: <PageNotFound /> },
];

export default publicRoutes;
